var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"enhanced-comment"},[_c('CommentaryPlusEditor',{key:_vm.editorJsKey,attrs:{"blocks":_vm.text,"filter":_vm.filter,"isReadOnly":true},on:{"completed":_vm.completed}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }